// Voorvulling voor de dienst van een transportvoertuig, gelijk aan TransportVehicleShiftDefaults.cs.
// De planning gebruikt altijd de waarde van het voertuig zelf, nooit deze constanten.
export const DefaultTransportVehicleShiftStart = '08:00:00';
export const DefaultTransportVehicleShiftEnd = '18:00:00';
